<template lang="pug">
.container-restricao
    div(
        v-if='restricoes.length > 0',
        :class='restricoes[index].inibido ? "camada-inibida" : ""',
        v-for='(restricao, index) in listaRestricoes'
    )
        slot(name='botaoInibir', :restricao='restricoes[index]')
        .card-restricao
            .container-restricao-acoes(
                v-if='existeDadosGeoEspaciais(restricoes[index])'
            )
                div
                    el-button(
                        size='small',
                        icon='mdi mdi-crosshairs-gps',
                        @click='aplicarZoomRestricao(index)'
                    )
            p
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.departamento') }}:
                |
                | {{ restricao.dpto_desc || restricao?.properties?.dpto_desc || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.dist') }}:
                |
                | {{ restricao.dist_desc || restricao?.properties?.dist_desc || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.areaGeometriaAnalisadaHa') }}:
                |
                | {{ restricao?.areaGeometriaAnalisadaHa ? Number(restricao.areaGeometriaAnalisadaHa).toFixed(2) : restricao?.properties?.areaGeometriaAnalisadaHa ? Number(restricao.properties.areaGeometriaAnalisadaHa).toFixed(2) : '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.areaTotalFeatureHa') }}:
                |
                | {{ restricao?.areaTotalFeatureHa ? Number(restricao.areaTotalFeatureHa).toFixed(2) : restricao?.properties?.areaTotalFeatureHa ? Number(restricao.properties.areaTotalFeatureHa).toFixed(2) : '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.sup_ha_desmatamento') }}:
                |
                | {{ restricao.sup_ha || '-' }}
                br.codigoSobreposicao(v-if='restricao.codigoSobreposicao')
                b.codigoSobreposicao(v-if='restricao.codigoSobreposicao') {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.codigoSobreposicao') }}:
                |
                | {{ restricao.codigoSobreposicao }}
                br.codigoSobreposicao(
                    v-if='restricao.percentualSobreposicaoGeometria'
                )
                b.codigoSobreposicao(
                    v-if='restricao.percentualSobreposicaoGeometria'
                ) {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.percentualSobreposicaoGeometria') }}:
                |
                | {{ restricao.percentualSobreposicaoGeometria }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.periodo_ca') }}:
                |
                | {{ restricao.periodo_ca || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.clase_desc') }}:
                |
                | {{ restricao.clase_desc || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.clase_2') }}:
                |
                | {{ restricao.clase_2 || '-' }}
</template>

<script>
import formatters from '@/utils/formatters';

export default {
    name: 'desmatamento-infona-paraguai',

    data() {
        return {};
    },
    props: {
        restricoes: {
            type: Array,
            required: true
        },
        geometria: {
            type: Array,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    computed: {
        listaRestricoes: function () {
            return this.restricoes.map(value => {
                if (value.properties) {
                    return {
                        ...value.properties
                    };
                }
                return value;
            });
        }
    },

    methods: {
        aplicarZoomRestricao(index) {
            let geometriaQueNaoEstavaDentroDasRestricoes = null;
            if (this.geometria) {
                geometriaQueNaoEstavaDentroDasRestricoes =
                    this.geometria[index];
            }
            this.$emit(
                'aplicar-zoom-restricao',
                this.restricoes[index],
                geometriaQueNaoEstavaDentroDasRestricoes,
                index
            );
        },
        formatNumber(number) {
            return number
                ? Number(number).toLocaleString('pt-br', {
                      minimumFractionDigits: 2
                  })
                : '-';
        },
        formatNumberPercent(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2) + '%';
        },
        existeDadosGeoEspaciais(restricao) {
            const { geometry, geometria, properties } = restricao;

            if (properties?.latitude && properties?.longitude) {
                return true;
            }

            return (
                this.habilitarZoomRestricao &&
                (geometry || geometria || this.geometria)
            );
        }
    }
};
</script>
